import React, { Component } from 'react';

import { YesNoDialog } from 'Components';

class AreYouSureDialog extends Component {
  render() {
    const { shown, onConfirm, onCancel } = this.props;

    return (
      <YesNoDialog
        showDialog={shown}
        title={`Close Verification`}
        question={`Are you sure you want to close verification?`}
        yesCallback={onConfirm}
        noCallback={onCancel}
      />
    );
  }
}

export { AreYouSureDialog };



// WEBPACK FOOTER //
// ./src/pages/verificationclose/components/AreYouSureDialog.js